import React, { useState, useEffect } from 'react';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import { getShowBySlug } from '../../../../services/showService';

const SHOW_SLUG = 'expedientesdeldelito';
const EXPEDIENTES_LOGO_URL = 'https://files.tnonetwork.com/shows/logo/expedientesdeldelito.png';
const DEFAULT_DESCRIPTION = 'El espacio donde Atache encontrará credibilidad investigativa. Expedientes del Delito lleva el análisis sobre criminalidad, justicia y seguridad a cada rincón de Venezuela. Angélica Lugo, con su autoridad como periodista de investigación, otorga un sello de veracidad único a la marca dermocosmética. Su segmento "El Expediente de la Piel" y las entrevistas con especialistas médicos validan la eficacia de Atache desde la voz de los expertos.';

const ExpedientesSection = () => {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.up('sm'), { defaultMatches: true });
  const [synopsis, setSynopsis] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getShowBySlug(SHOW_SLUG).then((show) => {
      if (!cancelled && show && show.synopsis) setSynopsis(show.synopsis);
    });
    return () => { cancelled = true; };
  }, []);

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
          gutterBottom
          color="primary"
          align="center"
        >
          Programa ancla
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h4"
          gutterBottom
          align="center"
          color="primary"
        >
          Expedientes del Delito con Angélica Lugo
        </Box>
        <Typography align="center" sx={{ mb: 1 }}>
          <Link
            href="https://tnonetwork.com/show/expedientesdeldelito"
            target="_blank"
            rel="noopener noreferrer"
            color="primary"
            underline="hover"
          >
            tnonetwork.com/show/expedientesdeldelito
          </Link>
        </Typography>
        <Typography variant="body1" color="textSecondary" align="center" sx={{ maxWidth: 640, mx: 'auto' }}>
          {synopsis || DEFAULT_DESCRIPTION}
        </Typography>
      </Box>
      <Grid container spacing={4} alignItems="center">
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              position: 'relative',
              paddingBottom: '56.25%',
              height: 0,
              overflow: 'hidden',
              borderRadius: isSm ? 4 : 0,
              boxShadow: 3,
            }}
          >
            <Box
              component="iframe"
              src="https://www.youtube.com/embed/3cL0ijWChrE"
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                border: 0,
              }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title="Expedientes del Delito | TNO Network"
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box
            maxWidth={400}
            margin="0 auto"
            position="relative"
            sx={{
              minHeight: 220,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: 2,
              bgcolor: 'grey.100',
              overflow: 'hidden',
            }}
          >
            <Box
              component="img"
              src={EXPEDIENTES_LOGO_URL}
              alt="Logo Expedientes del Delito"
              sx={{
                maxWidth: '70%',
                height: 'auto',
                objectFit: 'contain',
              }}
            />
          </Box>
          <Box mt={3} textAlign="center">
            <Box
              component="img"
              src="https://files.tnonetwork.com/users/profile/angelicalugo2.jpeg"
              alt="Angélica Lugo - Expedientes del Delito"
              sx={{
                width: 120,
                height: 120,
                borderRadius: '50%',
                objectFit: 'cover',
                objectPosition: 'top center',
                boxShadow: 2,
              }}
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <Typography variant="subtitle1" fontWeight={600} sx={{ mt: 1 }}>
              Angélica Lugo
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Ancla de Expedientes del Delito | Credibilidad Investigativa
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ExpedientesSection;
